<template>
  <div id="method-chart">
    <GChart
      type="LineChart"
      :data="chartData"
      :options="chartOptions"
      style="width: 650px; height: 300px;"
      @ready="onChartReady"
      ref="gChart"
    />
  </div>
</template>

<script>

    import { GChart } from "vue-google-charts";

    export default {
      name: "LineFour2018",
      components: {
        GChart
      },
      props: {
        mydata : []
      },
      data() {
          return {
              chartData: this.mydata,
              chartOptions: {
                title: 'Year 2018',
                curveType: 'function',
                lineWidth: 3,
                width: 650,
                height: 300,
                annotations: {
                  style: 'line',
                  stem: { color: '#000000', length: 6 },
                  textStyle: { color: '#000000' }
                },
              },
              id: '',
              month: '',
              methods : '',
              pragmatics: '',
              aesthetics: '',
              impact: ''
          }
        },
        methods: {
          onChartReady(chart, google) {
            // now we have google lib loaded. Let's create data table based using it.
            this.createDataTable(chart, google);
          },
          createDataTable(chart, google) {

            var data = new google.visualization.DataTable();
           // data.addColumn('string', 'Id');
            data.addColumn('string', 'Month');
            data.addColumn('number', 'Method');
            data.addColumn('number', 'Pragmatics');
            data.addColumn('number', 'Aesthetics');
            data.addColumn({type:'string', role:'annotation'}); // annotation role col

            let rows = [];
            let count = 0;
            let impact = '';

            for(let index in this.chartData){
              if(this.chartData.hasOwnProperty(index)) {
                if(this.chartData[index].date === '2018'){

                 //  this.id = this.chartData[index].id.toString();
                   this.month = this.chartData[index].month;
                   this.methods = this.chartData[index].methods;
                   this.pragmatics = this.chartData[index].pragmatics;
                   this.aesthetics = this.chartData[index].aesthetics;

                   if(this.chartData[index].gatekeeping === 1){
                     impact = 'Impact';
                   }
                   rows[count] = [];
                   rows[count][0] = this.month;
                   rows[count][1] = this.methods;
                   rows[count][2] = this.pragmatics;
                   rows[count][3] = this.aesthetics;
                   rows[count][4] = this.impact;

                   count++;
                }
              }
            }
            data.addRows(rows);

            var view = new google.visualization.DataView(data);
            chart.draw(view, this.chartOptions);
          }
      },
      mounted()  {
        console.log('line four 2018');
      }
    }
</script>

<style scoped>

  #method-chart {
    width: 650px;
    height: 300px;
  }

</style>
